import { Component, Inject, OnInit } from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';

@Component({
  selector: 'app-member-gn1-dialog',
  templateUrl: './member-gn1-dialog.component.html',
  styleUrls: ['./member-gn1-dialog.component.scss']
})
export class MemberGN1DialogComponent implements OnInit {

  public member: any = {}

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.member = this.data
   }

  ngOnInit() {
  }

}
